import type { SVGProps } from 'react';

// Stroke-based search for the nav icon set (the fill-based
// SearchNormalOutline reads too thin next to the other nav glyphs).
// 28 grid, stroke 1.75, ink bounds matching lucide Calendar/Settings —
// verified by the measured-bounds table in the Icons/HeaderNavIcons story.
// The glass is drawn large so its center stays near the optical center, with
// the handle attached at the rim and reaching the bottom-right corner of the
// ink band — a detached iconsax-style tick degrades to a dot at 20px (see the
// SearchIconLab story for the candidates that were compared).
const SvgSearchNormal = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="13.333" cy="13.333" r="11" stroke="currentColor" strokeWidth={1.75} />
    <path
      d="M21.111 21.111L25.667 25.667"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgSearchNormal;
